// @flow
import { LEGO_PANE_WIDTH } from 'app/common/react/components/closeup/consts';
import type { Pin, ViewportSize } from 'app/common/react/components/closeup/types';
import {
  hasImageOrig,
  hasImage236x,
  hasImage564x,
  hasImages,
  hasPin,
} from 'app/common/react/components/closeup/utils';

type Args = {|
  imgSrc: string,
  inLegoCloseupView: boolean,
  isGif: boolean,
  pin: Pin,
  showCloseupContentRight: boolean,
  viewportSize: ViewportSize,
|};

const calculateImageDimensions = ({
  imgSrc,
  inLegoCloseupView,
  isGif,
  pin,
  showCloseupContentRight,
  viewportSize,
}: Args) => {
  const images = hasImages(hasPin({ pin }));
  const { image564x = {} } = hasImage564x(images) || {};
  const { imageOrig = {} } = hasImageOrig(images) || {};
  const image = Object.keys(image564x).length === 0 ? imageOrig : image564x;
  const origHeight = image.height;
  const origWidth = image.width;

  const { image236x = {} } = hasImage236x(hasImages(hasPin({ pin }))) || {};
  const previewImgSrc = image236x.url;

  const wideWidth = inLegoCloseupView ? LEGO_PANE_WIDTH : 496;
  const oneColumnWidth = inLegoCloseupView ? LEGO_PANE_WIDTH : 564;
  const imageWidth =
    showCloseupContentRight && viewportSize === 'wide'
      ? Math.max(Math.min(origWidth, wideWidth), 60)
      : Math.max(Math.min(origWidth, oneColumnWidth), 60);
  const imageHeight = (imageWidth / origWidth) * origHeight;

  return {
    alt: pin.description,
    src: isGif ? imgSrc : previewImgSrc,
    naturalHeight: imageHeight,
    naturalWidth: imageWidth,
  };
};

export default calculateImageDimensions;
